import { PageUrl } from '../pages/utils/page-url';
import { getIsProduction } from './url-utils';

const noIndexPaths = [
    PageUrl.PWA_CART,
    PageUrl.CHECKOUT,
    PageUrl.CHECKOUT_LOGIN,
    PageUrl.CHECKOUT_BILLING,
    PageUrl.CHECKOUT_REVIEW,
    PageUrl.CHECKOUT_SHIPPING,
    PageUrl.SEARCH,
];

export const isNoIndexPage = (pathname: string | undefined | null): boolean => {
    const isProduction = getIsProduction();
    if (!pathname) return !isProduction;
    return (
        !isProduction ||
        noIndexPaths.some((path) => pathname.startsWith(path)) ||
        pathname.startsWith('/pwa')
    );
};
